
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"error.dialog.message":"Bitte wenden Sie sich an den Anwendungsbetreuer.","error.dialog.title":"Fehler beim Öffnen der erweiterten Auswahl"},"en":{"error.dialog.message":"Please contact the application administrator.","error.dialog.title":"Failed to open the extended selection"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();